export function extractPostDate(p) {
  if (!p) return new Date().toISOString();
  const candidates = [
    p.createdAt, p.DataCriacao, p.dataCriacao, p.CriadoEm, p.Data, p.DataPublicacao, p.created_at, p.CreatedAt,
    p.DataHora, p.dataHora, p.DataHoraPostagem, p.dataHoraPostagem
  ];
  for (const c of candidates) {
    if (!c) continue;
    const d = new Date(c);
    if (!isNaN(d.getTime())) return d.toISOString();
  }

  for (const k of Object.keys(p)) {
    const lk = k.toLowerCase();
    if (!(lk.includes('data') || lk.includes('date') || lk.includes('hora') || lk.includes('created'))) continue;
    const v = p[k];
    if (!v) continue;
    const d = new Date(v);
    if (!isNaN(d.getTime())) return d.toISOString();
  }

  return new Date().toISOString();
}

export function formatPostDate(isoOrDate) {
  if (!isoOrDate) return '';
  const d = new Date(isoOrDate);
  if (isNaN(d.getTime())) return String(isoOrDate);
  const pad = (n) => (n < 10 ? '0' + n : '' + n);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}, ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export function formatPostDateMinutes(isoOrDate) {
  if (!isoOrDate) return '';
  const d = new Date(isoOrDate);
  if (isNaN(d.getTime())) return String(isoOrDate);
  const pad = (n) => (n < 10 ? '0' + n : '' + n);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
